import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';
import { BaseHttpService } from '@src/app/core/http/base-http.service';
import { OrganizationHttpService } from '@src/app/core/http/organization-http.service';
import { TenantHttpService } from '@src/app/core/http/tenant.http.service';
import { SessionService } from '@src/app/core/session.service';
import { SharedModule } from '@src/app/shared';
import {
  IconType,
  InternalIcon,
} from '@src/app/shared/enums/internal-icon.enum';
import {
  OrganizationFilter,
  OrganizationInterface,
} from '@src/app/shared/interfaces/organization.interface';
import { BehaviorSubject, finalize } from 'rxjs';

@Component({
  selector: 'app-post-details-content',
  standalone: true,
  templateUrl: './post-details-content.component.html',
  imports: [CommonModule, SharedModule],
})
export class PostDetailsContentComponent {
  @Input() senderProfileImg?: string;
  @Input() senderId?: string;
  @Input() currentOrg?: OrganizationFilter;
  @Input() senderName?: string;
  @Input() dateTime?: any;
  @Input() showDate: boolean = true;
  @Input() copied: boolean = false;
  @Input() copyPostLink!: () => void;
  @Input() rawHtml?: string;
  @Input() streams?: any;
  @Input() category?: string;
  @Input() canViewDetails: boolean = true;
  @Input() showBackBtn: boolean = false;
  @Input() onBack?: () => void;
  @Input() peopleURL?: string;
  @Input() postData: any = {
    content: {
      streams: [],
      organization: null,
    },
  };

  isLoadingStreamOptions$ = new BehaviorSubject<boolean>(true);
  IconType = IconType;
  InternalIcon = InternalIcon;

  constructor(
    private orgHttpService: OrganizationHttpService,
    private tenantHttpService: TenantHttpService,
    private sessionService: SessionService
  ) {}
  // Initialize the component
  ngOnInit(): void {
    this.getStreamOptions();
    this.getCurrentOrg(this.postData);
  }

  getStreamOptions(): void {
    const { streams } = this.postData.content;
    this.loadStreamOptions(streams);
  }

  loadStreamOptions(id: number | number[]): void {
    let api$;
    let httpService: BaseHttpService<OrganizationInterface> | TenantHttpService;

    httpService = this.postData.content.organization
      ? this.orgHttpService
      : this.tenantHttpService;

    api$ = httpService.getStreamsByStreamId(id as number[]);

    api$
      .pipe(
        finalize(() => {
          this.isLoadingStreamOptions$.next(false);
        })
      )
      .subscribe((streams) => {
        this.streams = streams;
        const { streams: streamIds } = this.postData.content;
      });
  }

  get streamNames(): string {
    return (
      this.streams
        ?.filter((stream) =>
          this.postData?.content?.streams.includes(stream.id)
        )
        .map((stream) => stream.name)
        .join(', ') || ''
    );
  }

  get categoryName(): string {
    const categories = this.postData?.content?.categories || [];
    if (categories.length > 0) {
      return categories.map((cat) => cat.tagNames).join(', ');
    }
    return '';
  }

  getCurrentOrg(post): void {
    if (!this.currentOrg && post) {
      const { orgName } = post.content?.organization ?? {};
      // if (!orgName) return;
      this.currentOrg = {
        ...post?.content?.organization,
        name: orgName,
      } as unknown as OrganizationFilter;
    }
  }
}
